import React, { useEffect, useState } from "react";

import {
  createStripeAccountLink,
} from "../../../../services/staffingService";

import { Redirect, Link, useParams } from "react-router-dom";


import { useUser } from "../../../../context/UserContext";
import { useProviderCompany } from "../../../../context/ProviderCompanyContext";

import { CreditCard } from 'lucide-react';




import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";


const providerResourceSchema = yup.object({
  providerResourceEmail: yup
    .string()
    .required("Email is required for Provider Resource")
    .email("Must be a valid email address"),
});

const Account = () => {
  const { userInfo, userInfoReady } = useUser();

  const { providerCompanyId } = useParams();
  const { providerCompanyData, fetchProviderCompanyData } =  useProviderCompany();
  const [loading, setLoading] = useState(true);
  const [showSideDrawer, setShowSideDrawer] = useState(false);

  const [resourceResponse, setResourceResponse] = useState("");
  const [resourceError, setResourceError] = useState(false);


  const {
    register: registerResource,
    handleSubmit: handleSubmitResource,
    formState: { errors: errorsResource },
    reset: resetResource,
  } = useForm({
    resolver: yupResolver(providerResourceSchema),
  });



  const onSubmitProviderResource = async (data) => {
    console.log(data)
  };

  useEffect(() => {
    if (providerCompanyId) {
      fetchProviderCompanyData(providerCompanyId);
      setLoading(false);
    }
  }, [providerCompanyId, fetchProviderCompanyData]);

  const stripeIntegration = async () => {
    setLoading(true);
    try {
      const resp = await createStripeAccountLink(providerCompanyId);
      window.location.href = resp.data.accountLink;
    } catch (error) {
      setLoading(false);
      console.error("Failed to create Stripe account link:", error);
    }
  };

  return (
    <>
  
  {providerCompanyData && (
  <>
    <div>
      {
        // No Stripe account exists
        !providerCompanyData.stripeAccount && (
          <div className="flex items-start bg-white rounded-lg shadow-sm p-4 mb-4">
            <CreditCard className="text-orange-500 mr-5 mt-1" style={{ fontSize: "20px" }} />
            <div>
              <h6 className="mb-1 text-sm font-semibold text-brand-blue-dark">
                No Stripe Account Found
              </h6>
              <p className="mb-2 text-sm text-gray-600">
                You don't have a Stripe account connected yet. Please set up a Stripe account for payments.
              </p>
              <button
                onClick={stripeIntegration}
                className="px-2 py-1 rounded-lg bg-brand-blue-dark text-white text-sm font-medium hover:opacity-90 transition-opacity"
              >
                Set up Stripe Account
              </button>
            </div>
          </div>
        )
      }

      {
        // Full verification: charges enabled, details submitted, and payouts enabled
        providerCompanyData.stripeAccount &&
        providerCompanyData.stripeAccount.charges_enabled &&
        providerCompanyData.stripeAccount.details_submitted &&
        providerCompanyData.stripeAccount.payouts_enabled && (
          <div className="flex items-start bg-white rounded-lg shadow-sm p-4 mb-4">
            <CreditCard className="text-green-500 mr-5 mt-1" style={{ fontSize: "20px" }} />
            <div>
              <h6 className="mb-1 text-sm font-semibold text-brand-blue-dark">
                Congratulations! Your Stripe account is verified
                and ready to receive payments and make payouts.
              </h6>
              <p className="mb-2 text-sm text-gray-600">
                Your account is fully verified and you can start
                transactions.
              </p>
              <a
                href="https://dashboard.stripe.com/dashboard"
                target="_blank"
              >
                <button className="px-2 py-1 rounded-lg bg-brand-blue-dark text-white text-sm font-medium hover:opacity-90 transition-opacity">
                  Go to Dashboard
                </button>
              </a>
            </div>
          </div>
        )
      }

      {
        // No email provided yet
        providerCompanyData.stripeAccount &&
        !providerCompanyData.stripeAccount.email && (
          <div className="flex items-start bg-white rounded-lg shadow-sm p-4 mb-4">
            <CreditCard className="text-orange-500 mr-5 mt-1" style={{ fontSize: "20px" }} />
            <div>
              <h6 className="mb-1 text-sm font-semibold text-brand-blue-dark">
                Manage Payments
              </h6>
              <p className="mb-2 text-sm text-gray-600">
                Configure Stripe for identity verification and <br /> financial transactions.
              </p>
              <button
                onClick={stripeIntegration}
                className="px-2 py-1 rounded-lg bg-brand-blue-dark text-white text-sm font-medium hover:opacity-90 transition-opacity"
              >
                Go
              </button>
            </div>
          </div>
        )
      }

      {
        // Email provided but details not submitted
        providerCompanyData.stripeAccount &&
        providerCompanyData.stripeAccount.email &&
        !providerCompanyData.stripeAccount.details_submitted && (
          <div className="flex items-start bg-white rounded-lg shadow-sm p-4 mb-4">
            <CreditCard className="text-orange-500 mr-5 mt-1" style={{ fontSize: "20px" }} />
            <div>
              <h6 className="mb-1 text-sm font-semibold text-brand-blue-dark">
                Complete Your Stripe Setup
              </h6>

              <button
                onClick={stripeIntegration}
                className="px-2 py-1 rounded-lg bg-brand-blue-dark text-white text-sm font-medium hover:opacity-90 transition-opacity"
              >
                Complete Verification
              </button>
            </div>
          </div>
        )
      }
    </div>
  </>
)}

{loading && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg p-6 flex items-center space-x-3">
      <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
      <span className="text-gray-700">Loading...</span>
    </div>
  </div>
)}


    </>
  );
};
export default Account;
